@for (lang of allowedLanguages; track lang.code) {
    <button
        (click)="switchLanguage(lang.code)"
        value="{{ lang.code }}"
        matTooltip="{{ lang.name }}"
        mat-menu-item
        [class.selected]="lang.code === selectedLanguage.code">
        @if (showText()) {
            <span>&nbsp;{{ lang.code | uppercase }}</span>
        }
    </button>
}
